module.exports = __webpack_public_path__ + "img/target_visualization_1.54976b14.jpg";